import React, {useContext} from 'react';
import {Maybe} from 'monet';
import {useFixedTranslation} from '@/i18n';
import Icon from '@/views/shared/Icon';
import DownloadFileButton from '@/views/shared/DownloadFileButton';
import {PolicyStatementCtx} from '@/b2b/contexts';
import {getCurrentPolicy} from '@/b2b/pages/PolicyStatement/state';

const ProviderStatement = () => {
  const [state] = useContext(PolicyStatementCtx);
  const {providerStatementPath} = getCurrentPolicy(state);
  const {statementLanguage} = state;

  const tr = useFixedTranslation(statementLanguage, 'statement');

  const Download = () => (
    <div className='text-right'>
      {tr('provider_statement')}
      <DownloadFileButton
        className='btn btn-link btn-sm'
        path={providerStatementPath}
      >
        <span>
          {' '}
          <Icon icon='file-pdf' />{' '}
        </span>
      </DownloadFileButton>
    </div>
  );

  return Maybe.fromFalsy(providerStatementPath)
    .map(() => <Download />)
    .orNull();
};

export default ProviderStatement;
